import { Circle, Popup } from "react-leaflet";
import { Radar, Eye } from "lucide-react";

const COLOR = { high: "#B91C1C", medium: "#D97706", low: "#2D6A4F" };
const color = (s) => COLOR[(s || "").toLowerCase()] || "#78350F";

export function OutbreakLayer({ outbreaks }) {
  return outbreaks.map((o, i) => (
    <Circle key={i} center={[o.lat, o.lon]} radius={3500 + Math.min(o.count, 8) * 1500}
      pathOptions={{ color: color(o.severity), fillColor: color(o.severity), fillOpacity: 0.28, weight: 1.5, className: "outbreak-spot" }}>
      <Popup>
        <div style={{ minWidth: 180 }}>
          <div style={{ fontWeight: 700, color: "#143D29" }}>{o.problem}</div>
          <div style={{ fontSize: 12, color: "#57534e" }}>{o.type}{o.crops?.length ? ` · ${o.crops.join(", ")}` : ""}</div>
          <div style={{ fontSize: 12, marginTop: 4 }}><b style={{ color: color(o.severity) }}>{o.severity}</b> severity · {o.count} report{o.count > 1 ? "s" : ""} · {o.distance_km} km away</div>
          <div style={{ fontSize: 11, color: "#a8a29e", marginTop: 2 }}>Last seen {new Date(o.last_seen).toLocaleDateString()}{o.mine ? " · includes your report" : ""}</div>
        </div>
      </Popup>
    </Circle>
  ));
}

export function OutbreakList({ outbreaks, enabled, onToggle, onPick }) {
  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-4" data-testid="outbreak-list">
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs uppercase tracking-wider text-stone-500 font-semibold flex items-center gap-1"><Radar className="h-3.5 w-3.5 text-[#78350F]" /> Spreading near you</div>
        <label className="flex items-center gap-2 text-xs text-stone-600 cursor-pointer">
          <input data-testid="outbreak-toggle" type="checkbox" checked={enabled} onChange={(e) => onToggle(e.target.checked)} className="accent-[#78350F]" /> Show on map
        </label>
      </div>
      {outbreaks.length === 0 ? (
        <p className="text-sm text-stone-500" data-testid="outbreak-empty">No pest or disease sightings shared within 150 km in the last 60 days.</p>
      ) : (
        <ul className="space-y-1.5">
          {outbreaks.slice(0, 6).map((o, i) => (
            <li key={i}>
              <button data-testid={`outbreak-item-${i}`} onClick={() => onPick(o)} className="w-full text-left rounded-lg px-3 py-2 hover:bg-[#FAF9F6] flex items-start gap-2.5">
                <span className="mt-1.5 h-2.5 w-2.5 rounded-full shrink-0" style={{ backgroundColor: color(o.severity) }} />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-semibold text-emerald-950 text-sm truncate">{o.problem}</span>
                    <span className="text-[11px] text-stone-500 shrink-0 font-mono-tech">{o.distance_km} km</span>
                  </div>
                  <div className="text-[11px] text-stone-500">{o.count} report{o.count > 1 ? "s" : ""}{o.crops?.length ? ` · ${o.crops.slice(0, 2).join(", ")}` : ""}{o.mine ? <span className="inline-flex items-center gap-0.5 ml-1 text-[#78350F]"><Eye className="h-3 w-3" /> yours</span> : null}</div>
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
      <p className="text-[10px] text-stone-400 mt-2">Sightings are anonymised and rounded to ~5 km. Nobody can see who reported them.</p>
    </div>
  );
}
